import React, { createContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language?.split('-')[0] || 'en');
  const [availableLanguages] = useState([
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'nl', name: 'Nederlands' }
  ]);

  useEffect(() => {
    // Update current language when i18n language changes
    const lang = i18n.language?.split('-')[0] || 'en'; // Handle locales like 'en-US'
    setCurrentLanguage(lang);
  }, [i18n.language]);

  const changeLanguage = async (languageCode) => {
    try {
      await i18n.changeLanguage(languageCode);
      // Ensure we always store just the language code, not locale
      const lang = languageCode.split('-')[0];
      setCurrentLanguage(lang);
      
      // Store the language preference in localStorage
      localStorage.setItem('language', lang);
      
      // Update user language preference in backend if the user is logged in
      const token = localStorage.getItem('token');
      if (token) {
        try {
          // This would usually call an API endpoint to update user settings
          // For now, we'll just log it
          console.log(`Language preference updated to ${lang}`);
        } catch (error) {
          console.error('Failed to update language preference in backend', error);
        }
      }
      
      return true;
    } catch (error) {
      console.error('Failed to change language', error);
      return false;
    }
  };

  const value = {
    currentLanguage,
    availableLanguages,
    changeLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;